import { createAction, props } from '@ngrx/store';

import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { RejectionReason, SelfPublish, SelfPublishesParams } from '../self-publishes.interface';

export const setSelfPublishes = createAction(
  '[Self Publishes Component] Set Self Publishes',
  props<{ selfPublishes: BackendResponse<SelfPublish>; params: SelfPublishesParams; pageNumber: number }>()
);

export const switchAdvancedOptions = createAction('[Self Publishes Component] Switch Advanced Options');

export const setRejectionReasons = createAction(
  '[Self Publish Component] Set Rejection Reasons',
  props<{ rejectionReasons: RejectionReason[] }>()
);

export const request = {
  getRejectionReasons: createAction('[Request/Api Self Publish] Get Rejection Reasons'),
  loadSelfPublishes: createAction(
    '[Request/Api Self Publishes] Load Self Publishes',
    (params: SelfPublishesParams, pageNumber: number = 1, notification?: string) => ({ params, pageNumber, notification })
  )
};
